module.exports = __webpack_public_path__ + "static/static-stars-41927940b2599b9c3b4e9fcea21d0301.jpg";